import { get } from 'lodash'

import { getExpandedPath } from '@helpers'
import { ConfiguredColumn, ObjectDataRecord } from '@types'

export const getColumnObjectExpandedDisplayValue = (
  srcObj: ObjectDataRecord,
  column: ConfiguredColumn
) => {
  if (!column.value || !column.objectValue) {
    return undefined
  }

  const expandedDisplayPath = getExpandedPath(`${column.value}.${column.objectValue}`).join('.')

  return get(srcObj, expandedDisplayPath)
}
